import { useParams } from "@tanstack/react-router";

export function useGroupSlug(): string;
export function useGroupSlug(safe: false): string | undefined;
export function useGroupSlug(safe = true): string | undefined {
  const { groupSlug } = useParams({ strict: false });
  if (!groupSlug && safe) {
    throw new Error("Group is not defined");
  }
  return groupSlug ?? "";
}
